import { render, staticRenderFns } from "./PortalBlock.vue?vue&type=template&id=146caacf&"
import script from "./PortalBlock.vue?vue&type=script&lang=js&"
export * from "./PortalBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports